// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YsgvG","controls":"styles_controls__Gsp3a","charLimit":"styles_charLimit__1GFej","input":"styles_input__3z1iW","send":"styles_send__1mP43"};